module.exports = __webpack_public_path__ + "static/images/pass-card-no.0515d86.png";